import { Component, Input } from '@angular/core';
import { DurationInterface } from '@vendasta/sales-orders';
import { DurationTotal, TaxOption, UILineItem } from '../order-form/order-item-list/interface';

@Component({
  selector: 'store-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss'],
})
export class OrderSummaryComponent {
  @Input() orderItems: UILineItem[];
  @Input() taxOptions: TaxOption[];
  @Input() duration: DurationInterface;
  @Input() loading: boolean;
  @Input() expanded: boolean;
  @Input() showPricing = true;
  @Input() partnerId: string;
  @Input() marketId: string;
  @Input() estimatedTotal?: DurationTotal[];
}
